import { render, staticRenderFns } from "./RaceCalendarDetail.vue?vue&type=template&id=5024e32e&scoped=true&"
import script from "./RaceCalendarDetail.vue?vue&type=script&lang=js&"
export * from "./RaceCalendarDetail.vue?vue&type=script&lang=js&"
import style0 from "./RaceCalendarDetail.vue?vue&type=style&index=0&id=5024e32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024e32e",
  null
  
)

export default component.exports